var carData = {
    //弹幕(浏览次数、关注次数)
    GetBarrage(applyId,token) {
        return $.ajax({
            dataType: "json",
            type: "post",
            url: `${process.env.DSC_BASE_URL}/applyAuctionOrderApi/queryBarrageV3?applyId=${applyId}&_security_token=${token}`
        })
    },
    //拍卖是否真的结束
    GetEndTime(aucId) {
        return $.ajax({
            dataType: "json",
            type: "get",
            url: `${process.env.CYP_BASE_URL}/api/Auction/GetCarEndTime?aucId=${aucId}`
        })
    },
    //出价记录
    GetBidList(aucId,token) {
        return $.ajax({
            dataType: "json",
            type: "get",
            headers:{
                onlineid: token
            },
            url: `${process.env.CYP_BASE_URL}/api/Auction/GetBidsListByAucId?aucId=${aucId}&top=10000&requestType=1`
        })
    },
    //同步token
    SyncToken(token) {
        return $.ajax({
            dataType: "json",
            type: "post",
            url: `${process.env.DSC_BASE_URL}/publicApi/syncToken.json?token=${token}`
        })
    },
    //根据申请单id查询所有车商
    GetAllDealer(applyId,token) {
        return $.ajax({
            dataType: "json",
            type: "get",
            url: `${process.env.DSC_BASE_URL}/auctionDealerAction/getAllDealerByApplyId.json?applyId=${applyId}&_security_token=${token}`
        })
    },
    GetAuthPower(token) {
        return $.ajax({
            dataType: "jsonp",
            type: "get",
            url: `${process.env.DSC_PAR_URL}/httpApi/getAuthz.jsonp?_security_token=${token}`,
        })
    },

	//报价单初始化
	GetQuotationDetail(reportCode) {
		return $.ajax({
			dataType: "json",
			type: "get",
			url: `${process.env.CYP_BASE_URL}/api/CarData/CompleteReport?reportCode=${reportCode}`
		})
	},
	//报价单价格有效期
	GetPriceValidity(carId,isLookPrice) {
		return $.ajax({
			dataType: "json",
			type: "get",
			url: `${process.env.DSC_BASE_URL}/detailAction/getShareExpectContractPrice.json?carId=${carId}&isLookPrice=${isLookPrice}`
		})
	},
    /*
    * 暗拍 获取状态的接口
    * */
    GetAuctionInfoByAucIds(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.CYP_BASE_URL}/api/Auction/GetAuctionInfoByAucIds`
        })
    },
    /*
    * 暗拍获取shopMemberCode 建立长链接
    * */
    syncUser(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_BASE_URL}/publicApi/syncUser.json`
        })
    },


    /*
    * 平台化查询拍卖车辆信息
    * */
    findCarDetail(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/findCarDetail.json`
        })
    },

    /*
	* 高级拍卖详情初始化页面的接口
	* */
    FindAuctionDetail(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/findAuctionDetail.json`
        })
    },

    //确认流拍
	ConfirmUnsold(applyId,token) {
		return $.ajax({
			dataType: "json",
			type: "post",
			url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/confirmUnsold.json?applyId=${applyId}&token=${token}`
		})
	},

    //二次上拍
	SecondaryShot(data) {
		return $.ajax({
			dataType: "json",
			type: "post",
			url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/secondApplyAuction.json?applyId=${data.applyId}&reservePrice=${data.reservePrice}&token=${data.token}`
		})
    },

    //确认成交
	ConfirmDeal(data) {
		return $.ajax({
			dataType: "json",
			type: "post",
			url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/confirmDeal.json?applyId=${data.applyId}&token=${data.token}`
		})
    },

    //确认成交审批
	CommitTransactionApproval(data) {
		return $.ajax({
			dataType: "json",
			type: "post",
			url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/commitTransactionApproval.json?applyId=${data.applyId}&token=${data.token}`
		})
    },
    
    /*
    * 获取快拍自动流拍时长接口
    * */
    findRemainingBeatTime(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/findRemainingBeatTime.json?applyId=${data.applyId}&token=${data.token}`
        })
    },

    /*
    * 高级拍卖出价记录接口
    * */
    FindPriceList(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/findPriceList.json`
        })
    },
    /*
    * 快拍预展中撤销拍卖
    * */
    previewTakeOffCar(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/previewTakeOffCar.json`
        })
    },
    /**
     * 获取上拍提示语
     */
    getTakeOffInformation(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/getTakeOffInformation.json`
        })
    },
    /**
     * 修改一口价场次
     */
    updateYkjInfo(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/updateGoodsInfo.json`
        })
    },
    /**
     * 发起撮合
     */
    postMatchOrder(data) {
        return $.ajax({
            dataType: "json",
            data: data,
            type: "post",
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/createMatchOrder.json`
        })
    },
    /**
     * 是否有撮合单
     */
    hasMatchOrder(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/hasMatchOrder.json`
        })
    },
    /**
     * 店铺配置撮合
     */
    fetchMatchConfig(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/applyAuctionApi/getAllowedPlatformMatchup.json`
        })
    },
    /**
     * 获取建议保留价区间
     */
    fetchBasePriceRange(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/applyAuctionApi/getSecondReservePrice.json`
        })
    },
    /**
     * 校验二次上拍保留价
     */
    validateBasePrice(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/applyAuctionApi/getIsSurpassBasePriceAndPublishNumber.json`
        })
    },
    /**
     * 本车是否有人工审核单
     */
    hasManualCheck(data) {
        return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/applyAuctionApi/getIsHasApply.json`
        })
    },
    /**
     * 保留价提交人工审核
     */
    submitBasePriceCheck(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/applyAuctionApi/applyBasePriceInfo.json`
        })
    },
    /**
     * 分享图片上传换取链接
     */
    uploadShareImg(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/pictureTransferApi/upPictureTransfer.json`
        })
    },
    /**
     * 获取兜底玩法规则配置
     */
    getEnquiryInfo(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/applyAuctionApi/getSnapshootEnquiryInfo.json`
        })
    },
    /**
     * 获取兜底规则配置
     */
    getProtectBottomRule(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/applyAuctionApi/getSnapshootProtectBottomRuleByTenantCodeAndStoreCode.json`
        })
    },
    /**
     * 获取全部出价记录
     */
    getAllQueryPriceRecord(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/queryPriceApi/getAllQueryPriceRecordByApplyId.json`
        })
    },
    /**
     * 获取修改人列表
     */
    getChangePricePerson(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/queryPriceApi/getTopEndPriceByApplyId.json`
        })
    },
    /**
     * 获取兜底top几记录
     */
    getTopQueryPrice(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/queryPriceApi/getTopQueryPriceByApplyId.json`
        })
    },
    /**
     * 发起改价成交
     */
    postChangePrice(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/applyAuctionApi/doutiDeal.json`
        })
    },
    /**
     * 获取是否支持改价
     */
    fetchChangePriceConfig(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/applyAuctionApi/isShowDouDiCuoheButton.json`
        })
    },
    /**
     * 房间拍继续预展
     */
    submitPreview(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/submitPreview.json`
        })
    },
    /**
     * 成交概率
     */
    getTradeRatio(data) {
        return $.ajax({
            dataType: "json",
            type: "post",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/applyAuctionApi/getTradeRatio.json`
        })
    },
    /**
     * 发起撮合按钮的展示（是否满足平台策略）
     */
     getPlatformConfig(data){
         return $.ajax({
            dataType: "json",
            type: "get",
            data: data,
            url: `${process.env.DSC_PLATFORM_URL}/auction/auctionManagerApi/canStartMatch.json`
         })
     }
};

export default carData;



// WEBPACK FOOTER //
// ./src/assets/js/platform.js